module.exports = __webpack_public_path__ + "static/media/10.46d3c6b6.jpg";